import { useForm } from 'react-hook-form'
import { useSpeciesSearchContext } from '../context/speciesSearch'
import { SpeciesList, Spinner } from '../components'
import { useEffect } from 'react'
import { useIsFetching } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

type FormInput = { input: string }

const Home = () => {
  const { lastSearchResult, lastSearchInput, setLastSearchInput } =
    useSpeciesSearchContext()

  const { register, watch, setValue } = useForm<FormInput>()
  const isFetching = useIsFetching({ queryKey: ['search', lastSearchInput] })

  const watchInput = watch('input')

  useEffect(() => {
    if (watchInput) setLastSearchInput(watchInput)
  }, [watchInput, setLastSearchInput])

  return (
    <>
      <div className="mt-6 flex flex-wrap rounded-md sm:w-full md:w-1/2 xl:w-1/3">
        <form className="w-full">
          <div className="form-group mb-4">
            <div className="flex">
              <label
                htmlFor="input"
                className="text-1xl mb-2 mr-3 font-bold text-gray-800"
              >
                Search
              </label>
              {isFetching > 0 && <Spinner size={5} />}
            </div>
            <div className="flex">
              <input
                type="text"
                className="block w-full rounded-none rounded-l-md border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-serblue-light focus:ring-serblue-light"
                placeholder="Start typing a genus and species name to search"
                defaultValue={lastSearchInput}
                autoComplete="off"
                aria-autocomplete="none"
                autoCorrect="none"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') e.preventDefault()
                }}
                {...register('input')}
              />
              <button
                onClick={(e) => {
                  e.preventDefault()
                  setValue('input', '')
                }}
                className="text-md inline-flex items-center rounded-r-md border border-l-0 border-gray-300 bg-gray-200 p-2.5 px-3 text-gray-900 focus:border-serblue-light focus:ring-serblue-light"
              >
                ｘ
              </button>
            </div>
          </div>
        </form>
      </div>
      {lastSearchResult && lastSearchResult.length > 0 && (
        <SpeciesList speciesList={lastSearchResult} />
      )}
    </>
  )
}

export const Route = createFileRoute('/')({
  component: Home,
})
